import { ModalProps } from '../..//modal/modal';
import { DragAndDropProps } from '../../drag-and-drop/drag-and-drop';

export const DEFAULT_TOTAL_ROWS_TEXT = 'Total rows:';
export const DEFAULT_COLUMNS_SELECTED_TEXT = 'Columns selected:';
export const DEFAULT_SHOW_FIRST_ROW = true;
export const DEFAULT_SHOW_DOWNLOAD_TEMPLATE = true;
export const DEFAULT_DOWNLOAD_TEMPLATE_BUTTON_TEXT = 'Download Template';
export const DEFAULT_TEMPLATE_FILE_NAME = 'template_csv_file';
export const DEFAULT_LINES_IMPORTED_TEXT = 'Total lines imported:';
export const DEFAULT_LINES_UPLOADED_TEXT = 'Total lines uploaded:';
export const DEFAULT_LINES_WITH_ERRORS_TEXT = 'Total lines with errors:';
export const DEFAULT_UPLOAD_TEXT = 'Upload';
export const DEFAULT_FINISH_TEXT = 'Close';

export interface IAutoCompleteOption {
	label: React.ReactNode;
	value: string;
}

interface CSVModalTexts {
	title: string;
	okText: string;
	cancelText: string;
	description?: string;
	totalRowsText?: string;
	columnsSelectedText?: string;
	templateFileName?: string;
	downloadTemplateButtonText?: string;
	linesUploadedText?: string;
	linesImportedText?: string;
	linesWithErrorsText?: string;
	uploadText?: string;
	finishText?: string;
}

export type CSVModalHeader = {
	field_name: string;
	field_index: number;
};

export interface ExternalElementsProps {
	disabled?: boolean;
	className?: string;
}

export interface CSVUploaderProps {
	headers?: CSVModalHeader[];
	headersOptions?: IAutoCompleteOption[];
	onUpload: (updatedHeaders: CSVModalHeader[], csvFile: Blob) => Promise<CsvUploadResult>;
	onClose: () => void;
	autoCompleteProps?: ExternalElementsProps;
	dragAndDropClassName?: string;
	tableProps?: any;
	showFirstRow?: boolean;
	showDownloadTemplate?: boolean;
	texts?: CSVModalTexts;
	dragAndDropProps?: Partial<DragAndDropProps>;
}
export interface CSVUploadModalProps extends CSVUploaderProps {
	modalProps?: ModalProps;
}

export enum CSVUploaderState {
	DraggerView,
	TableView,
	Uploading,
	ResultsView
}

export type CsvUploadResult = {
	uploaded_number: number;
	failed_number: number;
	imported_number: number;
	errors: string[];
};
